/**
 * Created by Nisarg on 8/1/2017.
 */
import React, {Component} from 'react';
import firebase from 'firebase';
import $ from 'jquery';
import _HauteFire from './HauteFire';
import Filters from './Filters';
import Select from 'react-super-select';

const HauteFire = new _HauteFire();

export default class PartyIslands extends Component {
    constructor() {
        super();

        this.state = {
            AllIslands: [],
            PartyIslands: [],
            CopyPartyIslands: [],
            PartyCategory: {}
        }
    }

    componentDidMount() {
        $("body, html").animate({
            scrollTop: $("#secPartyBanner").position().top
        });

        this.getAllIslands();
        this.getPartyCategory();
        HauteFire.setBanner();

        //Google Analytics
        HauteFire.hauteGoogleAnalytics();
    }

    getAllIslands() {
        const _this = this;
        let islandRef = firebase.database().ref("IslandDetails/");
        islandRef.on('value', ((response) => {
            let AllIslands = response.val();
            if (AllIslands) {
                let keys = Object.keys(AllIslands);
                AllIslands = keys.map((key) => {
                    return AllIslands[key]
                });
                _this.setState({AllIslands});

                let PartyIslands = [];
                for (let i = 0; i < AllIslands.length; i++) {
                    let island = AllIslands[i].category.filter((category) => {
                        return category.name.trim().toLowerCase() == "party"
                    });
                    if (island != null && island.length > 0) {
                        PartyIslands.push(AllIslands[i]);
                    }
                }
                if (PartyIslands.length > 0) {
                    PartyIslands = PartyIslands.sort((a, b) => {
                        return a.order - b.order
                    });

                    _this.setState({PartyIslands, CopyPartyIslands: PartyIslands});
                }
            }
        }))
    }

    getPartyCategory() {
        const _this = this;
        let privateRef = firebase.database().ref("CategoryDetails");
        privateRef.orderByChild("name").equalTo('Party').on('value', ((response) => {
            let PartyCategory = response.val();
            if (!$.isEmptyObject(PartyCategory)) {
                PartyCategory = PartyCategory[Object.keys(PartyCategory)];

                if (PartyCategory.categoryPics.bannerPicObj) {
                    // $("#secPartyBanner").css({
                    //     "background-image": "url(" + PartyCategory.categoryPics.bannerPicObj.url + ")",
                    //     "background-size": "cover"
                    // });
                }

                _this.setState({PartyCategory});
            }
        }))
    }

    goToIslandDetails(e) {
        const name = e.currentTarget.attributes["data-islandName"].value;
        if (name != "") {
            this.props.history.push("/island/" + name);
        }
    }

    scrollToElem(e) {
        const elemId = e.currentTarget.attributes["data-elemId"].value;
        $('html, body').animate({
            scrollTop: $("#" + elemId).offset().top
        }, 2000);
    }

    renderPartyIslands(island, index) {
        let bannerPic;
        const islandPics = island.islandPics;
        if (islandPics) {
            bannerPic = islandPics.bannerPic != undefined ? islandPics.bannerPic.url : "";
        }
        const countryName = !$.isEmptyObject(island.address) ? island.address.substr(island.address.lastIndexOf(',') + 1).trim() : "";
        const price = !$.isEmptyObject(island.price) ? island.price : "";
        let priceTag = "";
        if (price != (undefined || "")) {
            for (let i = 0; i < price; i++) {
                priceTag += "$";
            }
        }
        const imgHeight = HauteFire.isMobile() ? 'auto' : 300;
        return (
            <div className="gallery bottom-space" key={index}>
                <figure className="gallery-img-wrap">
                    <img src={bannerPic} alt={island.name}
                         style={{height: imgHeight, cursor: 'pointer'}}
                         data-islandName={island.name} onClick={(e) => this.goToIslandDetails(e)}/>
                </figure>
                <div className="gallery-info clearfix">
                                <span className="gallery-name" style={{cursor: 'pointer'}} data-islandName={island.name}
                                      onClick={(e) => this.goToIslandDetails(e)}>{island.name}, <span
                                    className="gallery-fig-name">{countryName}</span></span>
                    <ul className="gallery-property-nav">
                        <li><a><i
                            className="icon-flag"></i>PARTY ISLAND</a></li>
                        <li><a><i
                            className="icon-price"></i>{priceTag}</a></li>
                        <li><a><i
                            className="icon-location"></i>{countryName}</a></li>
                        {/*
                        <li><a><i
                            className="icon-heart"></i>WISHLIST</a></li>
                            */}
                    </ul>
                </div>
            </div>
        )
    }

    filterByOptions(continents, priceLists) {
        let {CopyPartyIslands} = this.state;
        let PartyIslands = HauteFire.filterBy(continents, priceLists, CopyPartyIslands);

        this.setState({PartyIslands});
    }

    render() {
        const options = [
            {"id": 1509102511557, "name": "$$", "value": 2},
            {"id": 1509102514558, "name": "$$$", "value": 3},
            {"id": 1509102517558, "name": "$$$$", "value": 4},
            {"id": 1509102508557, "name": "$$$$$", "value": 5}
        ];

        const continents = [
            {id: 1509102934239, value: "Asia", name: "Asia"},
            {id: 1509102937238, value: "Africa", name: "Africa"},
            {id: 1509102940239, value: "North America", name: "North America"},
            {id: 1509102943238, value: "South America", name: "South America"},
            {id: 1509102946238, value: "Antarctica", name: "Antarctica"},
            {id: 1509102949238, value: "Europe", name: "Europe"},
            {id: 1509102952240, value: "Australia/Oceania", name: "Australia/Oceania"}
        ]

        return (
            <div>
                <section id="secPartyBanner" className="sec-banner banner parallax-party" data-parallax="scroll">
                    <img className="img-banner bannerpic"
                         src={!$.isEmptyObject(this.state.PartyCategory) && this.state.PartyCategory.hasOwnProperty('categoryPics') ? this.state.PartyCategory.categoryPics.bannerPicObj.url : ""}
                         alt={!$.isEmptyObject(this.state.PartyCategory) ? this.state.PartyCategory.name : ""}/>
                    <div className="div-explore hautecontainer">
                        <h1>Party till the sun comes up</h1>
                        <span className="banner-content">Cocktails. DJs. No time limits. This is your hedonistic universe.</span>
                        <a className="explore-btn button" style={{cursor: 'pointer'}}
                           data-elemId="explore" onClick={(e) => this.scrollToElem(e)}>explore</a>
                    </div>
                </section>

                <Filters filterByOptions={this.filterByOptions.bind(this)}/>

                <section className="gallery-sec party-gallery animated fadeInUp visible" data-animation="fadeInUp"
                         data-animation-delay="200" id="explore">
                    <div className="hautecontainer clearfix">

                        {this.state.PartyIslands.length > 0 ? this.state.PartyIslands.map((island, index) => {
                            return this.renderPartyIslands(island, index)
                        }) : ""}


                    </div>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/PartyIslands.js